import { Box, List } from '@factorialco/deprecated-design-system'
import isNil from 'lodash/isNil'

import { observer } from 'mobx-react'

import { CHANNEL_ORDER } from 'modules/notifications/components/Preferences/PreferencesList/_Category/constants'
import { CategoryHeader } from 'modules/notifications/components/Preferences/PreferencesList/_CategoryHeader'
import { PreferencesItem } from 'modules/notifications/components/Preferences/PreferencesList/_PreferencesItem'
import type {
  CategoryPreferences,
  NotifierPreferences,
} from 'modules/notifications/components/Preferences/PreferencesList/hooks/useComputedPreferences'
import type UserPreference from 'modules/notifications/store/models/UserPreference'

export interface Props {
  category: CategoryPreferences
}

function sortNotifiersByOrder(
  aPreferences: NotifierPreferences,
  bPreferences: NotifierPreferences
) {
  if (!isNil(aPreferences.orderInCategory) && !isNil(bPreferences.orderInCategory)) {
    return aPreferences.orderInCategory - bPreferences.orderInCategory
  }

  // Things without order (nil) to the end
  if (!isNil(aPreferences.orderInCategory)) {
    return -1
  }
  if (!isNil(bPreferences.orderInCategory)) {
    return 1
  }

  return 0
}

function sortNotifiers(aPreferences: NotifierPreferences, bPreferences: NotifierPreferences) {
  const byOrder = sortNotifiersByOrder(aPreferences, bPreferences)

  if (byOrder !== 0) {
    return byOrder
  }

  return aPreferences.title.localeCompare(bPreferences.title)
}

export interface Props {
  category: CategoryPreferences
  onPreferenceUpdated: (preference: UserPreference, newValue: boolean) => Promise<void>
  onScopeUpdated: (notifier: string, newValue: string) => Promise<void>
}

export const Category = observer(({ category, onPreferenceUpdated, onScopeUpdated }: Props) => {
  const filteredNotifiers = Object.values(category.notifiers).filter((notifier) => {
    return CHANNEL_ORDER.some((channel) => Object.keys(notifier.channelData).includes(channel))
  })

  if (filteredNotifiers.length === 0) {
    return null
  }

  return (
    <Box paddingY="s48" flexDirection="column" gap="s24">
      <CategoryHeader category={category} onPreferenceUpdated={onPreferenceUpdated} />
      <List>
        {/* We filter this to not show notifiers which only contains channels that aren't on
        CHANNEL_ORDER */}
        {filteredNotifiers.sort(sortNotifiers).map((notifier) => (
          <PreferencesItem
            key={notifier.identifier}
            notifier={notifier}
            onPreferenceUpdated={onPreferenceUpdated}
            onScopeUpdated={onScopeUpdated}
          />
        ))}
      </List>
    </Box>
  )
})
